import { useRef, useState } from "react";

export function useFocus(removeOnPointerUp = true) {
    const [focus, _setFocus] = useState(false);
    const refRef = useRef();
    function setFocus(value) {
        if (value) refRef.current.focus();
        else refRef.current.blur();
    }
    const controllerRef = useRef(null);
    function setRef(ref) {
        if (ref == null) {
            controllerRef.current.abort();
            return;
        }
        refRef.current = ref;
        const controller = new AbortController();
        controllerRef.current = controller;
        ref.addEventListener("focus", () => _setFocus(true), { signal: controller.signal });
        ref.addEventListener("blur", () => _setFocus(false), { signal: controller.signal });
        if (removeOnPointerUp) document.addEventListener("pointerup", () => setFocus(false), { signal: controller.signal });
    }
    return {setRef, focus, setFocus};

}